export default "__VITE_ASSET__Cbxbilg0__"